// MIT License - Copyright (c) 2026 Doug McNall
import {
  DashboardIcon,
  PackageIcon,
  TagIcon,
  ShoppingCartIcon,
  UsersIcon,
  UserIcon,
  ChefHatIcon,
  FlameIcon,
  FactoryIcon,
  TruckIcon,
  CreditCardIcon,
  DollarSignIcon,
  SettingsIcon
} from './Icons';

// Centralized icon mapping for consistent usage across the app
export const IconMap = {
  dashboard: DashboardIcon,
  orders: ShoppingCartIcon,
  customers: UsersIcon,
  coupons: TagIcon,
  products: PackageIcon,
  categories: TagIcon,
  recipes: ChefHatIcon,
  reviews: FlameIcon,
  revenue: DollarSignIcon,
  manufacturing: FactoryIcon,
  shipping: TruckIcon,
  'payment-gateways': CreditCardIcon,
  users: UserIcon,
  system: SettingsIcon,
  'api-test': SettingsIcon
};

// Helper function to get icon component by name
export const getIcon = (iconName, size = 16, className = '') => {
  const IconComponent = IconMap[iconName];
  return IconComponent ? <IconComponent size={size} className={className} /> : null;
};

export default IconMap;
